import { moneyFilter, spaceNumber } from "../modules/utils";

/**
 * Permet d'ajouter les filters.
 */
export default {
  install(Vue) {
    Vue.filter("moneyFilter", moneyFilter);
    Vue.filter("spaceNumber", spaceNumber);
  },
};
